import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth, formatApiError } from "../context/AuthContext";
import Seo from "../components/Seo";
import { toast } from "sonner";
import { useLanguage } from "../context/LanguageContext";

export default function Login() {
  const { t } = useLanguage();
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success(t("Bentornato"));
      nav("/dashboard");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || t("Errore login"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[80vh] grid grid-cols-1 lg:grid-cols-2">
      <Seo title="Accedi al tuo account Rarium" description="Accedi al tuo account collezionista Rarium per seguire i tuoi lotti preferiti e fare offerte." path="/login" noindex />
      <div className="hidden lg:block bg-stone-900 relative overflow-hidden grain">
        <img src="https://images.pexels.com/photos/17483087/pexels-photo-17483087.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" alt="" className="w-full h-full object-cover opacity-70" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
        <div className="absolute bottom-10 left-10 text-stone-50 max-w-md">
          <div className="overline text-[#B49A5F]">Rarium</div>
          <div className="font-serif text-4xl mt-2 leading-tight">{t("L'accesso privato ai lotti più rari.")}</div>
        </div>
      </div>
      <div className="flex items-center justify-center p-8 lg:p-16">
        <form onSubmit={submit} className="w-full max-w-sm">
          <div className="overline text-stone-500">{t("Accedi")}</div>
          <h1 className="font-serif text-4xl tracking-tighter mt-2">{t("Bentornato.")}</h1>
          <div className="mt-8 flex flex-col gap-6">
            <label className="flex flex-col">
              <span className="overline text-stone-500 mb-2">Email</span>
              <input data-testid="login-email" type="email" required value={email} onChange={e=>setEmail(e.target.value)} className="border-b border-stone-300 bg-transparent py-3 px-0 focus:border-stone-900 focus:outline-none" />
            </label>
            <label className="flex flex-col">
              <span className="overline text-stone-500 mb-2">{t("Password")}</span>
              <input data-testid="login-password" type="password" required value={password} onChange={e=>setPassword(e.target.value)} className="border-b border-stone-300 bg-transparent py-3 px-0 focus:border-stone-900 focus:outline-none" />
            </label>
            <button data-testid="login-submit" disabled={busy} className="mt-4 text-xs uppercase tracking-widest font-semibold bg-stone-900 hover:bg-[#8C3A3A] text-stone-50 px-8 py-4 transition-colors disabled:opacity-50">{busy?"…":t("Accedi")}</button>
          </div>
          <div className="mt-6 text-sm text-stone-600 flex justify-between">
            <Link to="/register" className="underline-hover text-[#8C3A3A]">{t("Registrati")}</Link>
            <Link to="/forgot-password" data-testid="forgot-link" className="underline-hover">{t("Password dimenticata?")}</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
